/*eslint-disable*/
import React, { useState, useEffect, Fragment } from "react";
import { useNavigate } from "react-router-dom";

import APIClient from "../client";
import config from "../config.js"
import TableChart from "../components/Charts/TableChart.js";
import FunderEditPopUp from "../components/Modals/FunderEditModal.js";
import AuthNavbar from "../components/Navbars/AuthNavbar.js";

import '../assets/styles/App.css';
import '../assets/styles/tailwind.css';
import "@fontsource/montserrat";
import {Link} from "react-router-dom";


const client = new APIClient(config);


export default function AdminFunderCapital() {
    const navigate = useNavigate();

    const [data, setData] = useState(null);
    const [columnData, setColumnData] = useState(null);
    const [funderData, setFunderData] = useState(null);
    const [openEdit, setOpenEdit] = useState(false);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchFunders();
    }, []);

    const fetchFunders = () => {
        client.getFunderCapitalViews().then((data) => {
            setLoading(false);
            setData(data['data']['data']);
            const columns = [
                {
                    key: "action",
                    text: "Action",
                    className: "action",
                    width: 100,
                    align: "left",
                    sortable: false,
                    cell: (record) => {
                        return (
                            <Fragment>
                                <Link
                                    className="get-started text-blue rounded py-1 px-7 bg-yellow"
                                    to={"/capitalmanagement"}
                                    state={[{"funder_view_id": record.funder_view_id,
                                        "display_name": record.funder_capital_view.display_name}]}
                                >
                                    &nbsp;
                                    <i className="fa fa-plus-circle" aria-hidden="true"></i>
                                    &nbsp; Add Capital &nbsp;
                                </Link>
                            </Fragment>
                        );
                    },
                },
                {
                    name: "Portfolio",
                    selector: (row) => row.funder_capital_view.display_name,
                },
                {
                    name: "funder_view_id",
                    selector: (row) => row.funder_view_id,
                },
                {
                    name: "avg_net_book",
                    selector: (row) => row.avg_net_book,
                },
                {
                    name: "total_fee",
                    selector: (row) => row.total_fee,
                },
                {
                    name: "start_date",
                    selector: (row) => row.start_date,
                },
                {
                    name: "id",
                    omit: true,
                    selector: (row) => row.id,
                },
            ];

            setColumnData(columns);

            setError(null);
        });
    };

    const ExpandedComponent = ({ data }) => <pre>{JSON.stringify(data, null, 2)}</pre>;
    const screenSize = (window.innerWidth >= 912);
    const screenSizeTwo = (window.innerWidth >= 1024);

    document.title = "Funder Capital";

    return (
        <>
            <section>
                <AuthNavbar />
            </section>

            <section className="relative grad-1 pb-20">
                <div className="container relative mx-auto pt-12 px-4 w-10/12">

                    {loading && (
                        <div className="text-xl font-medium">Loading...</div>
                    )}
                    {error && <CardError message={error}/>}

                    {data && (

                        <>


                            <h2 className="text-36 text-yellow mb-6">Funder Capital</h2>

                            <TableChart
                                columns={columnData}
                                data={data}
                                defaultSortFieldId={1}
                                dense
                            />

                        </>


                    )}

                </div>
                {funderData ? (<FunderEditPopUp data={funderData} isOpen={openEdit}/>) : (<></>)}

                <div className="text-center mt-10">

                    <button
                        className="text-16-500 px-12 py-3 ml-3 mb-3 items-center text-blue bg-yellow rounded"
                        type="button"
                        onClick={() => navigate("/capitalmanagement")}
                    >
                        <i className="fa fa-plus" aria-hidden="true"></i>

                        &nbsp; Create Funder Capital Record &nbsp;
                    </button>

                </div>

            </section>

        </>
    );
}

